import {cn} from '@/lib/utils'
import React, {ForwardedRef} from 'react'
import './WuLoader.css'

export interface IWuLoaderProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: 'md' | 'lg' | 'sm' | string
  color?: string
  message?: string
  variant?: 'spinner' | 'dots'
}

export const WuLoader = React.forwardRef<HTMLDivElement, IWuLoaderProps>(
  (props, ref) => {
    return dots(props, ref)
  },
)
/**
 * WuLoader do not support any custom design.
 */
const dots = (
  props: IWuLoaderProps,
  ref: ForwardedRef<HTMLDivElement>,
): React.JSX.Element => {
  const {size = 'md', color = '#1B87E6', variant = 'dots', ...rest} = props
  const dotContainerClass = cn('spinner wu-loader-dot-container')
  let sizeInPx = '7px'
  if (size === 'sm') {
    sizeInPx = '7px'
  } else if (size === 'md') {
    sizeInPx = '12px'
  } else if (size === 'lg') {
    sizeInPx = '18px'
  } else if (typeof size === 'string') {
    sizeInPx = size
  }
  const dotStyle = {
    backgroundColor: color,
    width: sizeInPx,
    height: sizeInPx,
  }

  const spinnerLoader = (
    <div
      {...rest}
      ref={ref}
      className={cn(
        'flex items-center justify-center gap-2 w-fit',
        props.className,
      )}
      role="status"
      aria-busy="true"
    >
      <div
        className="w-12 h-12 border-2 rounded-full animate-spin"
        style={{
          width: sizeInPx,
          height: sizeInPx,
          borderTopColor: color,
        }}
      />
      {props.message && (
        <p className="message wu-loader-message">{props.message}</p>
      )}
    </div>
  )

  const dotsLoader = (
    <div
      {...rest}
      ref={ref}
      className={cn(
        'flex items-center justify-center gap-2 w-fit',
        props.className,
      )}
      // https://stackoverflow.com/questions/38704467/how-to-label-a-loading-animation-for-wai-aria
      role="alert"
      aria-busy="true"
    >
      <ul
        className={dotContainerClass}
        style={{fontSize: sizeInPx}}
        role="loader"
      >
        <li className="dot wu-loader-dot" style={dotStyle}></li>
        <li className="dot wu-loader-dot" style={dotStyle}></li>
        <li className="dot wu-loader-dot" style={dotStyle}></li>
        <li className="dot wu-loader-dot" style={dotStyle}></li>
      </ul>
      {props.message && (
        <p className="message wu-loader-message">{props.message}</p>
      )}
    </div>
  )

  return <>{variant === 'spinner' ? spinnerLoader : dotsLoader}</>
}

WuLoader.displayName = 'WuLoader'
